import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentMethodDisable } from '../../../redux/actions/paymentMethods';

const DisablePaymentMethodModal = ({ payload, showDisablePaymentMethodModal, setShowDisablePaymentMethodModal, paymentMethod, disablePaymentMethod }) => {
  const disable = () => {
    disablePaymentMethod(payload, paymentMethod.id);
    setShowDisablePaymentMethodModal(false);
  }

  return(
    <>
      { paymentMethod &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowDisablePaymentMethodModal(false),
            },
            { text: 'Disable Payment Method', onClick: () => disable() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Disable Payment Method"
          isOpen={showDisablePaymentMethodModal}
          onClose={() => setShowDisablePaymentMethodModal(false)}
        >
          <H3>Disable {paymentMethod.method_name}</H3>
          <Text>
            Confirm that this payment method should be disabled. Suppliers using this payment method by default will no longer have a default payment method set.
          </Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  disablePaymentMethod: (payload, paymentMethodId) => dispatch(paymentMethodDisable(payload, paymentMethodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisablePaymentMethodModal);